import { Camera, Notification, Setting2 } from "iconsax-reactjs"
import { useEffect, useState } from "react"

import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { sendOpenSettings } from "@/modules/helpers/utils"
const CONTENTS = {
  ["CAMERA_PERMISSION_DENIED"]: {
    title: "Cần quyền truy cập camera",
    body: "Để chụp ảnh và quay video, ứng dụng cần quyền truy cập camera của bạn.",
    button: "Mở cài đặt",
    icon: <Camera className="w-8 h-8 text-blue-600" />,
    color: "blue"
  },
  ["NOTIFICATION_PERMISSION_DENIED"]: {
    title: "Cần quyền truy cấp thông báo`",
    body: "Để cung cấp dịch vụ dựa trên thông báo, ứng dụng cần quyền truy cấp thông báo của bạn.",
    button: "Mở cài đặt",
    icon: <Notification size={32} className="text-green-600" />,
    color: "green"
  }
}
export function PopUpPermission() {
  const [type, setType] = useState<string>("")
  useEffect(() => {
    const handleAction = (event: CustomEvent<{ type: string }>) => {
      if (
        ["CAMERA_PERMISSION_DENIED", "NOTIFICATION_PERMISSION_DENIED"].includes(event.detail.type)
      ) {
        setType(event.detail.type)
      }
    }

    window.addEventListener("openSettings", handleAction as EventListener)
    return () => {
      window.removeEventListener("openSettings", handleAction as EventListener)
    }
  }, [])
  const content = CONTENTS[type as keyof typeof CONTENTS]

  if (!type || !content) return null

  return (
    <Dialog open={!!type} onOpenChange={() => setType("")}>
      <DialogContent className="max-w-[90%]">
        <DialogHeader className="text-center">
          <div className="flex justify-center mb-2">
            <div
              className={`w-13 h-13 rounded-full flex items-center justify-center ${
                content.color === "blue" ? "bg-blue-50" : "bg-green-50"
              }`}
            >
              {content.icon}
            </div>
          </div>
          <DialogTitle className="text-sm font-semibold text-gray-900">{content.title}</DialogTitle>
        </DialogHeader>

        <div className="text-center gap-2 flex flex-col">
          <p className="text-gray-600 text-xs leading-relaxed">{content.body}</p>

          <div className="gap-2 flex w-full">
            <Button
              variant="outline"
              onClick={() => setType("")}
              className="flex-1 text-xs border-gray-300 text-gray-600 hover:bg-gray-50 font-medium py-3 rounded-lg"
            >
              Đóng
            </Button>
            <Button
              onClick={() => {
                setType("")
                sendOpenSettings()
              }}
              className="flex-1 text-xs bg-gray-900 hover:bg-gray-800 text-white font-medium py-3 rounded-lg"
            >
              <Setting2 size={16} className="mr-2" />
              {content.button}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
